import React, { FunctionComponent } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import TextInputField from "../../../Components/TextInput/TextInputField";
import ButtonField from "../../../Components/Button/ButtonField";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import {
  adminCreateUser,
  clearCreateUserState,
} from "../../../Redux/Slicers/Users/UsersCreateSlicer";
import { AdminCreateUserPayload } from "../../../Redux/Slicers/Users/UsersApi";
import { getUsers } from "../../../Redux/Slicers/Users/UsersSlicer";

interface CreateUserModalProps {
  onClose: () => void;
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").nullable(),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^\+[1-9]\d{1,14}$/, "Include country code (e.g. +1234567890)"),
});

const CreateUserModal: FunctionComponent<CreateUserModalProps> = ({
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.UsersCreate);

  const formik = useFormik<AdminCreateUserPayload>({
    initialValues: {
      name: "",
      email: "",
      phone: "",
    },
    validationSchema,
    onSubmit: (values) => {
      dispatch(adminCreateUser(values));
      // After dispatch, simply close and refresh list.
      dispatch(clearCreateUserState());
      dispatch(getUsers());
      onClose();
    },
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      style={{ display: "flex", flexDirection: "column", gap: 16 }}
    >
      <TextInputField
        name="name"
        label="Name"
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.name && Boolean(formik.errors.name)}
        helperText={formik.touched.name && (formik.errors.name as string)}
      />
      <TextInputField
        name="email"
        label="Email"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.email && Boolean(formik.errors.email)}
        helperText={formik.touched.email && (formik.errors.email as string)}
      />
      <TextInputField
        name="phone"
        label="Phone"
        value={formik.values.phone}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.phone && Boolean(formik.errors.phone)}
        helperText={formik.touched.phone && (formik.errors.phone as string)}
      />
      {formik.errors && typeof formik.errors === "string" && (
        <span className="error-text">{formik.errors}</span>
      )}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <ButtonField
          className="cancel_button"
          type="button"
          onClick={onClose}
        >
          Cancel
        </ButtonField>
        <ButtonField
          className="add_button"
          type="submit"
          disabled={loading}
        >
          {loading ? "Creating..." : "Create"}
        </ButtonField>
      </div>
    </form>
  );
};

export default CreateUserModal;

